import { render } from "./FeaturesTwo.vue?vue&type=template&id=ce22dd4e"
import script from "./FeaturesTwo.vue?vue&type=script&lang=js"
export * from "./FeaturesTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__